import { app } from "@microsoft/teams-js";
import { ChannelAccountDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { FetchResult, channelApi, isSuccess } from "../services/ChannelApi";

export const useTeamsMembers = () => {
  const [teamMembers, setTeamMembers] = useState<ChannelAccountDTO[]>([]);
  const [isTeamsMembersLoading, setIsTeamsMembersLoading] = useState<boolean>(false);
  const [isTeamsMembersLoaded, setIsTeamsMembersLoaded] = useState<boolean>(false);
  const [teamsMembersErrors, setTeamsMembersErrors] = useState<FetchResult<ChannelAccountDTO[]>>();

  const loadTeamsMembers = useCallback(async (context: app.Context) => {
    setIsTeamsMembersLoading(true);
    setTeamsMembersErrors(undefined);
    const result = await channelApi.teamMembers(context);
    if (isSuccess(result)) {
      setTeamMembers(result);
      setIsTeamsMembersLoaded(true);
    } else {
      setTeamsMembersErrors(result);
    }
    setIsTeamsMembersLoading(false);
  }, []);

  const clearTeamsMembersErrors = () => {
    setTeamsMembersErrors(undefined);
  };

  return {
    loadTeamsMembers,
    teamMembers,
    teamsMembersErrors,
    isTeamsMembersLoading,
    isTeamsMembersLoaded,
    clearTeamsMembersErrors,
  };
};
